import React from "react";

export const BlogAuthorInfo = () => {
  return (
    <div className="blog-avatar-wrap mb-65">
      <div className="blog-avatar-img">
        <img src="/images/team/faisal.png" alt="Faisal Shabbir" />
      </div>

      <div className="blog-avatar-info">
        <span className="designation">Author</span>
        <h4 className="name">Faisal Shabbir</h4>

        <p>
          CEO of Zawix Business Consultants, with years of hands-on
          experience helping businesses across Pakistan with SECP, FBR, PEC,
          and other regulatory registrations.
        </p>
      </div>
    </div>
  );
};

